import { memo } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@/icons";
import styles from "../FullscreenPresentationLayout.module.scss";
import type { TurnDirection } from "../types";

type PageControlProps = {
    currentSlide: number;
    totalSlides: number;
    onTurnSlide: (direction: TurnDirection) => void;
};

export const PageControl = memo(({ currentSlide, totalSlides, onTurnSlide }: PageControlProps) => {
    return (
        <div className={styles.pageControl}>
            <button
                className={styles.navigationButton}
                type="button"
                onClick={() => onTurnSlide("prev")}
            >
                <ChevronLeftIcon />
            </button>

            <div className={styles.paging}>
                {currentSlide + 1} / {totalSlides}
            </div>

            <button
                className={styles.navigationButton}
                type="button"
                onClick={() => onTurnSlide("next")}
            >
                <ChevronRightIcon />
            </button>
        </div>
    );
});
